module.exports = __webpack_public_path__ + "static/HandBag3_zpsl3tctazj-505ddc0a8c791133f8527e0932bef5a8.jpg";